<h1 class="title">Your Events</h1>

<ul class="event-list">
  @for (event of eventList(); track event.id) { @if (!event.isPostEventReport) {
  <li class="event-item">
    <app-event
      [event]="event"
      [buttons]="buttons()"
      [isAdmin]="isAdmin()"
      (deleteEventClick)="delete($event)"
      (recalculateClick)="recalculate($event)"
      (getReportClick)="getReport($event, event.name)"
      (navToEventClick)="getEvent($event)"
      (createPostEventReportClick)="createPostEventReport($event)"
    ></app-event>
  </li>
  } } @empty {
  <li class="no-items">There are no items. Please create first</li>
  }
</ul>

<app-button
  [title]="'Create new event'"
  (buttonClick)="getEvent()"
  class="create-new-button__theme"
>
  <span class="create-icon"></span>
</app-button>

@if (isLoaderShown()) {
  <app-full-page-loader></app-full-page-loader>
}

<iframe id="pdf-frame" style="opacity: 0; height: 0; width: 0; visibility: hidden; overflow: hidden"></iframe>

@if (pdfIsLoading()) {
  <div class="loader">
    <mat-spinner></mat-spinner>
    <p>Report generation</p>
  </div>
}
